import { apiService } from './api'

const BASE = '/email-notifications'

// Sends must not be auto-retried by the api interceptor, or a slow provider could deliver twice.
const NO_RETRY = { _skipRetry: true }

const unwrap = (res) => res.data

const emailNotificationService = {
  getConfig: () => apiService.get(`${BASE}/config`).then(unwrap),

  saveRouting: (eventKey, routing) =>
    apiService.put(`${BASE}/config`, { eventKey, ...routing }).then(unwrap),

  getSchedule: () => apiService.get(`${BASE}/schedule`).then(unwrap),

  saveSchedule: (schedule) => apiService.put(`${BASE}/schedule`, schedule).then(unwrap),

  getStatus: ({ refresh = false } = {}) =>
    apiService.get(`${BASE}/status`, { params: refresh ? { refresh: 1 } : {} }).then(unwrap),

  sendTest: (eventKey, payload) =>
    apiService.post(`${BASE}/${encodeURIComponent(eventKey)}/test`, payload, NO_RETRY).then(unwrap),

  sendDigestNow: () => apiService.post(`${BASE}/schedule/send-now`, {}, NO_RETRY).then(unwrap),

  previewDigest: () =>
    apiService.post(`${BASE}/schedule/preview`, {}, NO_RETRY).then(unwrap),

  listManagementConfigs: () => apiService.get(`${BASE}/management`).then(unwrap),

  getManagementConfig: (eventKey) =>
    apiService.get(`${BASE}/management/${encodeURIComponent(eventKey)}`).then(unwrap),

  saveManagementConfig: (eventKey, payload) =>
    apiService.put(`${BASE}/management/${encodeURIComponent(eventKey)}`, payload).then(unwrap),

  previewManagement: (eventKey) =>
    apiService.post(`${BASE}/management/${encodeURIComponent(eventKey)}/preview`, {}, NO_RETRY).then(unwrap),

  sendManagementNow: (eventKey) =>
    apiService.post(`${BASE}/management/${encodeURIComponent(eventKey)}/send-now`, {}, NO_RETRY).then(unwrap),

  managementHistory: (eventKey, params = {}) =>
    apiService.get(`${BASE}/management/${encodeURIComponent(eventKey)}/history`, { params }).then(unwrap),

  getGstComplianceStage: (eventKey) =>
    apiService.get(`${BASE}/gst/${encodeURIComponent(eventKey)}`).then(unwrap),

  saveGstComplianceStage: (eventKey, payload) =>
    apiService.put(`${BASE}/gst/${encodeURIComponent(eventKey)}`, payload).then(unwrap),

  previewGstCompliance: (eventKey, payload = {}) =>
    apiService.post(`${BASE}/gst/${encodeURIComponent(eventKey)}/preview`, payload, NO_RETRY).then(unwrap),

  sendGstComplianceNow: (eventKey, payload = {}) =>
    apiService.post(`${BASE}/gst/${encodeURIComponent(eventKey)}/send-now`, payload, NO_RETRY).then(unwrap),

  gstComplianceHistory: (eventKey, params = {}) =>
    apiService.get(`${BASE}/gst/${encodeURIComponent(eventKey)}/history`, { params }).then(unwrap),
}

/** Message for a failed call; `handled` is true when the api interceptor already showed a toast. */
export function describeError(err, fallback = 'Something went wrong') {
  return {
    message: err?.response?.data?.message || err?.message || fallback,
    handled: Boolean(err?._errorHandled),
  }
}

export default emailNotificationService
